import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import SubscriptionProfit from '../atoms/SubscirptionProfit'
import NewButton from '../atoms/NewButton'
import EstigroupInput from '../atoms/EstigroupInput'
import EstigroupCheckbox from '../atoms/EstigroupCheckbox'
import Badge from '../atoms/Badge'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducer } from 'src/redux/rootReducer'
import { CLOSE_DEMO_MODAL, REQUEST_FULL_ACCESS } from 'dealer-reducers'
import CloseXSvg from '../other/svg/CloseXSvg'

const DemoModal = (): JSX.Element => {
  const { t } = useTranslation()
  const showModal = useSelector((state: RootReducer) => state.userDataReducer.show_demo_modal)
  const [companyId, setCompanyId] = useState('')
  const [companyName, setCompanyName] = useState('')
  const [address, setAddress] = useState('')
  const [city, setCity] = useState('')
  const [postalCode, setPostalCode] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [checked, setChecked] = useState(false)
  const [companyIdError, setCompanyIdError] = useState('')
  const [companyNameError, setCompanyNameError] = useState('')
  const [addressError, setAddressError] = useState('')
  const [cityError, setCityError] = useState('')
  const [postalCodeError, setPostalCodeError] = useState('')
  const [phoneNumberError, setPhoneNumberError] = useState('')
  const [privacyPolicyError, setPrivacyPolicyError] = useState('')
  const dispatch = useDispatch()
  const showDemoExpiredBadge = useSelector(
    (state: RootReducer) => state.userDataReducer.status === 'expired_test_access'
  )

  if (!showModal) {
    return <></>
  }

  const handleSubmit = (): void => {
    setCompanyIdError('')
    setCompanyNameError('')
    setAddressError('')
    setCityError('')
    setPostalCodeError('')
    setPhoneNumberError('')
    setPrivacyPolicyError('')

    if (companyId.trim().length === 0) {
      setCompanyIdError(t('demo_modal.form.errors.company_id_required'))
      return
    }

    if (companyName.trim().length === 0) {
      setCompanyNameError(t('demo_modal.form.errors.company_name_required'))
      return
    }

    if (address.trim().length === 0) {
      setAddressError(t('demo_modal.form.errors.address_required'))
      return
    }

    if (city.trim().length === 0) {
      setCityError(t('demo_modal.form.errors.city_required'))
      return
    }

    if (postalCode.trim().length === 0) {
      setPostalCodeError(t('demo_modal.form.errors.postal_code_required'))
      return
    }

    if (phoneNumber.trim().length === 0) {
      setPhoneNumberError(t('demo_modal.form.errors.phone_number_required'))
      return
    }

    if (!checked) {
      setPrivacyPolicyError(t('demo_modal.form.errors.privacy_policy_required'))
      return
    }
    dispatch(
      REQUEST_FULL_ACCESS({
        ftin: companyId,
        street: address,
        place: city,
        zip_code: postalCode,
        phone: phoneNumber,
        company_name: companyName
      })
    )
  }
  return (
    <div
      onClick={() => {
        dispatch(CLOSE_DEMO_MODAL())
      }}
      className="absolute top-0 left-0 z-[22222] w-screen h-screen bg-black/40 flex items-center justify-center">
      <div
        onClick={(e) => {
          e.stopPropagation()
        }}
        className="flex justify-start items-start bg-backgrounds-bg-base rounded-lg relative">
        <div className="w-[594px] pl-12 pr-6 py-10 bg-backgrounds-bg-base inline-flex flex-col justify-start items-start gap-3 overflow-hidden rounded-lg">
          <div onClick={() => dispatch(CLOSE_DEMO_MODAL())} className="absolute top-5 right-5 cursor-pointer">
            <CloseXSvg className="w-5 h-5 text-darkGrey" />
          </div>
          <div className="self-stretch py-3 flex flex-col justify-start items-start gap-3">
            {showDemoExpiredBadge && (
              <div className="h-5 px-1 bg-tag-neutral-tag-neutral-bg rounded-md outline outline-1 outline-offset-[-1px] outline-tag-neutral-tag-neutral-border inline-flex justify-center items-center gap-[3px]">
                <div className="text-center justify-start text-tag-neutral-tag-neutral-text text-xs font-medium font-['Open Sans'] leading-tight">
                  {t('demo_modal.demo_expired')}
                </div>
              </div>
            )}
            <div className="self-stretch justify-center">
              <span className="text-web-header text-4xl font-bold font-Montserrat leading-10">
                {t('demo_modal.title')} <br />
              </span>
              <span className="text-Estigroup-primary text-4xl font-bold font-Montserrat leading-10">
                {t('demo_modal.title_highlight')}
              </span>
            </div>
            <div className="self-stretch flex flex-col justify-start items-start gap-3">
              <div className="self-stretch justify-center text-web-text-body text-lg font-semibold font-['Open Sans'] leading-relaxed">
                {t('demo_modal.subtitle')}
              </div>
            </div>
          </div>
          <div className="self-stretch flex flex-col justify-start items-start gap-3">
            <div
              className="self-stretch p-4 bg-sky-100 rounded-2xl outline outline-2 outline-offset-[-2px] outline-borders-border-base flex flex-col justify-start items-start overflow-hidden"
              style={{ boxShadow: 'inset 0px 0px 0px 6px rgba(255,255,255,1.00)' }}>
              <div
                className="self-stretch bg-blue-500 rounded-lg flex flex-col justify-center items-start"
                style={{
                  boxShadow:
                    '0px 2px 4px 0px rgba(53,130,206,0.08), 0px 1px 2px 0px rgba(53,130,206,0.08), 0px 0px 6px 8px rgba(0,134,208,0.59)'
                }}>
                <div className="self-stretch p-6 flex flex-col justify-start items-start gap-4">
                  <Badge
                    text={t('demo_modal.badge')}
                    color="white"
                    withCheckBox={false}
                    backgroundColor="rgb(244 244 245 / 0.1)"
                    borderColor="rgb(244 244 245 / 0.1)"
                  />
                  <div className="self-stretch flex flex-col justify-start items-start gap-2">
                    <div className="self-stretch justify-center text-slate-50 text-2xl font-bold font-Montserrat leading-7">
                      {t('demo_modal.full_access_title')}
                    </div>
                    <div className="self-stretch justify-center text-slate-200 text-base font-semibold font-['Open Sans']">
                      {t('demo_modal.full_access_description')}
                    </div>
                  </div>
                </div>
                <div className="self-stretch flex flex-col justify-center items-center gap-2 overflow-hidden">
                  <div className="self-stretch inline-flex justify-center items-center gap-[3px] overflow-hidden"></div>
                </div>
                <div className="self-stretch px-6 py-4 flex flex-col justify-start items-start gap-4">
                  <div className="inline-flex justify-start items-end gap-1">
                    <div className="justify-center text-white text-3xl font-bold font-opensans leading-7">
                      {t('demo_modal.price')}
                    </div>
                    <div className="justify-center text-slate-50 text-sm font-medium font-opensans leading-tight">
                      {t('demo_modal.price_period')}
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-56 h-5" />
              <div className="self-stretch px-4 py-3 flex flex-col justify-start items-start gap-2">
                <SubscriptionProfit text={t('demo_modal.features.live_listings')} />
                <SubscriptionProfit text={t('demo_modal.features.bid_buy')} />
                <SubscriptionProfit text={t('demo_modal.features.priority_support')} />
                <SubscriptionProfit text={t('demo_modal.features.mobile_app')} />
              </div>
            </div>
            <div className="self-stretch justify-center text-web-text-body text-xs font-normal font-opensans leading-tight">
              {t('demo_modal.support_text')}
            </div>
          </div>
        </div>
        <div className="px-12 py-10 border-l border-borders-border-base inline-flex flex-col justify-center items-center gap-8 overflow-hidden flex-1 max-w-[400px] min-h-[720px]">
          <div className="self-stretch flex flex-col justify-start items-start gap-3">
            <div className="self-stretch justify-center text-web-header text-xl font-bold font-Montserrat leading-normal">
              {t('demo_modal.form.title')}
            </div>
            <div className="self-stretch justify-center text-web-text-body text-sm font-normal font-['Open Sans'] leading-snug">
              {t('demo_modal.form.description')}
            </div>
          </div>
          <div className="flex flex-col justify-start items-start gap-2">
            <EstigroupInput
              label={t('demo_modal.form.company_id')}
              placeholder={t('demo_modal.form.company_id_placeholder')}
              value={companyId}
              onChange={setCompanyId}
              error={companyIdError}
            />
            <EstigroupInput
              label={t('demo_modal.form.company_name')}
              placeholder={t('demo_modal.form.company_name_placeholder')}
              value={companyName}
              onChange={setCompanyName}
              error={companyNameError}
            />
            <EstigroupInput
              label={t('demo_modal.form.address')}
              placeholder={t('demo_modal.form.address_placeholder')}
              value={address}
              onChange={setAddress}
              error={addressError}
            />
            <EstigroupInput
              label={t('demo_modal.form.city')}
              placeholder={t('demo_modal.form.city_placeholder')}
              value={city}
              onChange={setCity}
              error={cityError}
            />
            <EstigroupInput
              label={t('demo_modal.form.postal_code')}
              placeholder={t('demo_modal.form.postal_code_placeholder')}
              value={postalCode}
              onChange={setPostalCode}
              error={postalCodeError}
            />
            <EstigroupInput
              label={t('demo_modal.form.phone_number')}
              placeholder={t('demo_modal.form.phone_number_placeholder')}
              value={phoneNumber}
              onChange={setPhoneNumber}
              error={phoneNumberError}
            />
            <div className="h-2" />
            <EstigroupCheckbox
              label={t('demo_modal.form.privacy_policy')}
              checked={checked}
              onChange={setChecked}
              error={privacyPolicyError}
            />
          </div>
          <NewButton buttonVariant="xlarge" buttonType="blue" onClick={handleSubmit}>
            {t('demo_modal.form.submit_button')}
          </NewButton>
        </div>
      </div>
    </div>
  )
}

export default DemoModal
